export default __webpack_public_path__ + "static/media/edit.1a11a4f3.svg";